import { useUserTypeQuery } from '@/domains/shared/api/queries/useUserTypeQuery';
import { createContext, useContext } from 'react';

type AccountContextValue = {
  userType?: 'public' | 'lead' | 'account';
  isLoading: boolean;
  refetch: () => Promise<void>;
};

const AccountContext = createContext<AccountContextValue | undefined>(
  undefined,
);

const AccountProvider = ({ children }: { children: React.ReactNode }) => {
  const { data, isLoading, refetch } = useUserTypeQuery();

  const wrappedRefetch = async () => {
    await refetch();
  };

  return (
    <AccountContext.Provider
      value={{ userType: data?.userType, isLoading, refetch: wrappedRefetch }}
    >
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within AccountProvider');
  }
  return context;
};

export default AccountProvider;
